const CAROUSEL_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20vibrant%20editorial%20illustration%20of%20celebrity%20scandal%20breaking%20news%20theme%2C%20coral%20pink%20and%20golden%20gradient%2C%20abstract%20newspaper%20fragments%20collage%20style%2C%20modern%20magazine%20cover%20design%2C%20dramatic%20but%20refined&width=1200&height=600&seq=carousel-01&orientation=landscape',
    title: '2026上半年娱乐大事件全回顾',
    tag: '年度专题',
    desc: '从年初至今，娱乐圈发生了太多值得铭记的时刻。我们整理了十大最具话题性的吃瓜事件，带你回顾这半年的精彩瞬间。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20illustration%20of%20film%20awards%20ceremony%20theme%2C%20peach%20and%20cream%20gradients%2C%20geometric%20trophy%20shapes%2C%20elegant%20editorial%20design%2C%20luxurious%20but%20minimalist&width=1200&height=600&seq=carousel-02&orientation=landscape',
    title: '金瓜奖年度评选：你的一票很重要',
    tag: '互动投票',
    desc: '首届52吃瓜网「金瓜奖」投票正式开启！最佳恋情、最轰动离婚、最反转剧情等八大奖项等你来选，参与即有机会赢取限量周边。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20minimalist%20illustration%20of%20behind%20the%20scenes%20documentary%20theme%2C%20soft%20rose%20and%20gold%20gradients%2C%20abstract%20film%20strip%20elements%2C%20editorial%20magazine%20style%2C%20clean%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
    title: '原创纪录片：一位娱记的二十年',
    tag: '独家出品',
    desc: '52吃瓜网首部原创纪录片上线。跟随资深娱乐记者老张的视角，走进二十年中国娱乐新闻的变迁史，揭秘那些年你不知道的编辑部故事。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20illustration%20of%20fan%20community%20celebration%20theme%2C%20coral%20and%20cream%20colors%2C%20flowing%20confetti%20shapes%2C%20festive%20editorial%20design%2C%20energetic%20and%20warm%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
    title: '吃瓜社区年度盛典：百万瓜友在线狂欢',
    tag: '社区活动',
    desc: '庆祝52吃瓜网月活突破800万！社区年度盛典火热进行中，瓜友故事征集、神评论大赛、吃瓜知识竞赛等精彩活动等你来玩，还有丰厚礼品相送。',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            重磅推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-500 mt-2">编辑精选，不容错过的深度内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group relative bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-full bg-white/90 text-primary-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl text-white mb-1.5">{item.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}